module.exports = "files/bulletLaunched.mp3";